import React from 'react';
import { INFLUENCER_RESCHEDULE_CUTOFF_HOURS } from '@foodfluence/shared';
import CollabConfirmedScreen, { type ConfirmedReminder } from './CollabConfirmedScreen';
import VisitSummaryCard from './VisitSummaryCard';

interface ScheduledSuccessScreenProps {
  timeLabel: string;
  locationLabel: string;
  brandName: string;
  brandLogoUrl?: string;
  creatorAvatarUrl?: string;
  partySizeLabel: string;
  /** Reschedule (not a first booking): different headline copy. */
  isReschedule?: boolean;
  /** Content due row ("Content due by" + date), when known. */
  postByLabel?: string;
  postByTitle?: string;
  onViewProgress: () => void;
  onHome: () => void;
}

const REMINDERS: ConfirmedReminder[] = [
  {
    title: 'Please try not to reschedule',
    body: `The business prepares for your visit and holds this time slot just for you. You can reschedule up to ${INFLUENCER_RESCHEDULE_CUTOFF_HOURS} hours before your scheduled visit.`,
  },
  {
    title: 'Please be respectful to staff',
    body: 'Please be respectful to the staff at the business.',
  },
  {
    title: 'Check your inbox',
    body: 'The business may require you to check in via the FoodFluence inbox a few days before your visit. Please respond to their messages promptly.',
  },
];

// The in-store visit's confirmation: the shared celebration screen, with the visit card as its
// summary and the visit-specific reminders.
const ScheduledSuccessScreen: React.FC<ScheduledSuccessScreenProps> = ({
  timeLabel,
  locationLabel,
  brandName,
  brandLogoUrl,
  creatorAvatarUrl,
  partySizeLabel,
  isReschedule = false,
  postByLabel,
  postByTitle,
  onViewProgress,
  onHome,
}) => (
  <CollabConfirmedScreen
    brandName={brandName}
    brandLogoUrl={brandLogoUrl}
    creatorAvatarUrl={creatorAvatarUrl}
    connectorLabel="Your Visit"
    title={isReschedule ? 'New time set' : "You're booked"}
    subtext={isReschedule ? `Your new time is set. See you at ${brandName}.` : `Collab accepted. See you at ${brandName}.`}
    reminders={REMINDERS}
    onViewCollab={onViewProgress}
    onHome={onHome}
  >
    <VisitSummaryCard
      brandName={brandName}
      brandLogoUrl={brandLogoUrl}
      locationLabel={locationLabel}
      timeLabel={timeLabel}
      partySizeLabel={partySizeLabel}
      postByLabel={postByLabel}
      postByTitle={postByTitle}
      bare
    />
  </CollabConfirmedScreen>
);

export default ScheduledSuccessScreen;
